import { bootstrap } from "@topi/shared/platform/bootstrap/bootstrap";
import { App, AvailableAppNames } from "./app";

const currentApp = import.meta.env.CURRENT_APP;

if (!currentApp) {
  throw new Error("currentApp is not set");
}

bootstrap(<App appType={currentApp as AvailableAppNames} />, currentApp);
